export const ANIMATION_CONFIG = {
    BOUNCE: {
        tension: 1200,
        friction: 40,
    },
} as const
